document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (e) => {
        const header = document.querySelector('.header')

        if (e.target.closest('[data-link]')) {
            e.preventDefault();
            const currentLink = e.target.closest('[data-link]')
            if (currentLink) {
                const currentSection = document.querySelector(`[data-anchor = ${currentLink.dataset.link}]`);
                if (currentSection) {
                    const yOffset = header ? -header.clientHeight : 0;
                    const y = currentSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({top: y, behavior: 'smooth'});
                } 
            }
        }
    })
})